import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function base(clientViewId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/piloto`;
}

async function parse(response, fallbackMessage) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || fallbackMessage);
  }
  return body;
}

export async function getPilotDashboard(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/panel`, { credentials: "include" });
  return parse(response, "No se pudo cargar el panel piloto.");
}

export async function getPilotStatus(clientViewId) {
  const response = await fetch(`${base(clientViewId)}`, { credentials: "include" });
  return parse(response, "No se pudo cargar el estado piloto.");
}

export async function evaluatePilotGates(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/puertas/evaluar`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  return parse(response, "No se pudieron evaluar las puertas de lanzamiento.");
}

export async function listPilotSeedBatches(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/lotes`, { credentials: "include" });
  return parse(response, "No se pudieron cargar los lotes piloto.");
}

export async function getPilotCoverage(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/cobertura`, { credentials: "include" });
  return parse(response, "No se pudo cargar la cobertura piloto.");
}

export async function getPilotDailyScorecard(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/scorecard`, { credentials: "include" });
  return parse(response, "No se pudo cargar el scorecard diario.");
}
